export const calculateTaxes = (price, taxes) => {
  return taxes.reduce((p, t) => p + price * (t.percent / 100), 0)
}
